export default {
  props: {
    creative: Object,
    permissions: Array,
    toggleElement: {
      default: 'commentCollapse',
    },
    identificator: {
      default: '',
    },
    noSpacing: {
      default: false,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/creative-preview-feedback/CreativePreviewFeedback.js